import React from "react";

import { Menu } from "antd";

import "antd/es/menu/style/css";

import { HashLink as Link } from "react-router-hash-link";

export default class Pages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: this.props.location.hash,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleClick = (e) => {
    this.setState({
      current: e.key,
    });
  };

  getRoutes = () => {
    return this.props.info.ROUTES;
    /* return [
      {
        PAGE_ID: 3,
        PARENT_ID: null,
        PAGE_NAME: "პროდუქცია",
        PARENT_NAME: null,
        URL: "/products",
        PARENT_URL: null,
        CHILDS: [],
      },
      {
        PAGE_ID: 1,
        PARENT_ID: null,
        PAGE_NAME: "სიახლეები",
        PARENT_NAME: null,
        URL: "/news",
        PARENT_URL: null,
        CHILDS: [],
      },
      {
        PAGE_ID: 2,
        PARENT_ID: null,
        PAGE_NAME: "მომსახურება",
        PARENT_NAME: null,
        URL: "/service",
        PARENT_URL: null,
        CHILDS: [],
      },
      {
        PAGE_ID: 4,
        PARENT_ID: null,
        PAGE_NAME: "ჩვენს შესახებ",
        PARENT_NAME: null,
        URL: "/about",
        PARENT_URL: null,
        CHILDS: [],
      },
      {
        PAGE_ID: 5,
        PARENT_ID: null,
        PAGE_NAME: "დაგვიკავშირდით",
        PARENT_NAME: null,
        URL: "/contact",
        PARENT_URL: null,
        CHILDS: [],
      },
    ]; */
  };

  renderMenu = () => {
    const menuArr = this.getRoutes();
    return menuArr.map((el) => {
      if (el.CHILDS.length === 0) {
        return (
          <Menu.Item key={el.URL}>
            <Link
              to={el.URL}
              scroll={(el) => {
                const elementPosition = el.offsetTop - 105;
                window.scroll({
                  top: elementPosition,
                  behavior: "smooth",
                });
                //el.scrollIntoView({ behavior: "smooth", top: "105" })
              }}
            >
              {el.PAGE_NAME}
            </Link>
          </Menu.Item>
        );
      } else {
        return (
          <Menu.SubMenu title={el.PARENT_NAME} key={el.PARENT_ID}>
            {el.CHILDS.map((elIn) => {
              return (
                <Menu.Item key={elIn.PARENT_URL + elIn.URL}>
                  <Link to={elIn.PARENT_URL + elIn.URL}>{elIn.PAGE_NAME}</Link>
                </Menu.Item>
              );
            })}
          </Menu.SubMenu>
        );
      }
    });
  };

  render() {
    return (
      <Menu
        onClick={this.handleClick}
        selectedKeys={[this.state.current]}
        mode="horizontal"
        style={{ /* lineHeight: "77.8px", */ textAlign: "right" }}
        className="top-menu"
      >
        {this.renderMenu()}
      </Menu>
    );
  }
}
